export const UPDATE_SYMPTOM_SUCCESS = 'UPDATE_SYMPTOM_SUCCESS'
export const UPDATE_SYMPTOM_FAIL = 'UPDATE_SYMPTOM_FAIL'
export const UPDATE_SYMPTOM_CLEAR_DATA = 'UPDATE_SYMPTOM_CLEAR_DATA'
